import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgPremiumlounge32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path d="M22.5 24a.5.5 0 1 1 0 1h-13a.5.5 0 1 1 0-1zM16.447 5.276l4.718 9.436 5.515-4.596c.392-.327.964.075.79.555l-4 11A.5.5 0 0 1 23 22H9a.5.5 0 0 1-.47-.33l-4-11a.5.5 0 0 1 .76-.577l6.482 4.63 3.764-9.409a.5.5 0 0 1 .911-.038m-.396 1.443-3.587 8.967a.5.5 0 0 1-.755.22l-5.688-4.063L9.35 21H22.65l3.247-8.93-4.577 3.814a.5.5 0 0 1-.767-.16z" className="premiumlounge-32_svg__path-1" /></SvgIcon>;
};
const Memo = memo(SvgPremiumlounge32);
export default Memo;